import { AttributeEnum } from 'src/app/enums/enums';
import { IUserAttribute } from 'src/app/interfaces';

// TODO This can be improved
export class UserAttributes {
  public userAttributes: IUserAttribute[] = [];

  constructor(_userAttributes: IUserAttribute[]) {
    this.userAttributes = _userAttributes;
  }

  // Made this a static function for now to address a bug in the user service worker
  /**
   * Fetches the attribute value based on the provided AttributeEnum {@link see AttributeEnum}
   *
   * @param attribute
   * @returns
   */
  static getValuesByAttribute(
    userAttribute: UserAttributes,
    attribute: AttributeEnum
  ): any {
    return userAttribute.userAttributes?.find(
      (val) => val.attribute === attribute
    )?.attributeValue;
  }
}
